export default {"src":"/_next/static/media/no_cars_placeholder.1a275267.svg","height":186,"width":717};